//--------------------------------
// set local combatants is ranked
//--------------------------------
export default function setLocalCombatantsIsRanked(combatants) {
  // console.log("--------------------------")
  // console.log("IN setLocalCombatantsIsRanked")
  combatants.forEach((c) => {
    if (!c.is_ranked) {
      c.is_ranked = true;
    }
  });
  return combatants;
}
